import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_DOMAINS_PRODUCT_ENABLED } from './api/mutation'
import { Data, Variables } from './api/types'
import { useSnackbar } from './useSnackbar'

export const useSwitchDomainsProduct = () => {
  const { snackbar } = useSnackbar()

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_DOMAINS_PRODUCT_ENABLED,
    onCompleted: async (data, variables) => {
      const {
        input: { enabledValue, productType },
      } = variables
      const { updateDomainsProductEnabled } = data

      if (updateDomainsProductEnabled) {
        const { errors } = updateDomainsProductEnabled

        if (errors && errors.length > 0) {
          snackbar(productType, enabledValue, 'error')
        } else {
          snackbar(productType, enabledValue)
        }
      }
    },
    queriesToInvalidate: ['getDomainsForTable'],
  })

  const update = (variables: Variables): void => void mutateAsync({ input: variables })

  return { update }
}
